export default {
  '员工管理': 'Employee',
  '生产小组':'Production group',
  '数据统计':'Data statistics',
  '订单详情':'Order details',
  '订单重做统计':'Order rework statistics',
  '订单修改':'Order modification',
  '添加订单':'Add order',
  '电子开版':'Electronic patterning',
  '模板库':'Template library',
  '模板详情':'Template details',
  '开版详情':'Pattern details',
  tongyongObj: {
    piliang:'Batch',
    piliangfahuo:'Batch shipment',
    daochuExcel:'Export Excel',
    xiazai:'Download',
    fankuitupian:'Feedback Images',
    xiazaichenggong:'Download successful',
    caozuoshibai:'Operation failed',
    qingqiushibai:'Request failed',
    xiaoshou: 'Sales',
    guanliyuan: 'Manager',
    shenfen: 'Identity',
    xiugaixinxi: 'Modify information',
    tuichu: 'Logout',
    shouye: 'Home',
    shujutongji: 'Data statistics',
    yuangongguanli: 'Employee',
    shengchanxiaozu: 'Production group',
    tianjiadingdan: 'Add Order',
    daorudingdanliebiao: 'Import Order List',
    xiazaidingdanmuban: 'Download Order Template',
    tishi: 'Tips',
    niquedingyaotuichudengluma: 'Are you sure you want to log out?',
    queding: 'Confirm',
    quxiao: 'Cancel',
    tuichuchenggong: 'Logout successfully',
    ninquedingyaochexiaogongxuma: 'Are you sure you want to cancel the process?',
    chexiaochenggong: 'Cancel successfully',
    yiquxiaochexiao: 'Canceled cancel',
    caozuochenggong: 'Operation successful',
    qingxuanzexiayibugongxu: 'Please select the next step process',
    mubanku: 'Template library',


    dingdantezhengxinxi: 'Order Feature Information',
    kaibanjichuxinxi: 'Basic Version Information',
    chongwupinlei: 'Pet Category',
    chongwutezheng: 'Pet Features',
    wenjianxinxi: 'File Information',
    xiazaikaibanwenjian: 'Download Version File',
    maoliaoxinxi: 'Material Information',
    mingcheng: 'Name',
    quyu: 'Area',
    beizhuxinxi: 'Note Information',
    beizhu: 'Note',
    zhengzainvlidaochu: 'Exporting...',
    qingshuruchongwupinlai: 'Please enter pet category',
    qingshuruneirong: 'Please enter content',
    kedianjixiazai: 'Click to download',

    maoliaomingcheng: 'Material Name',
    qingshurumaoliaomingcheng: 'Please enter material name',
    maoliaoquyu: 'Material Area',
    qingshurumaoliaoquyu: 'Please enter material area',
    wancheng: 'Complete',
    wanchengbingbaocunmuban: 'Complete and Save Template',
    yanjing: 'Eyes',
    bizi: 'Nose',
    jiaozhang: 'Paw',
    qingshurupinlei: 'Please enter category',
    qingshuruchongwutezheng: 'Please enter pet features',
    qingshurukaibanjichuxinxi: 'Please enter basic version information',
    qingshangchuankaibanwenjian: 'Please upload version file',
    pinlei: 'Category',
    maoliao: 'Material',
    tezheng: 'Features',
    sousuoneirong: 'Search Content',
    qingshurudingdanbianhao: 'Please enter order number',
    mubanbianhao: 'Template Number',
    dingdanhao: 'Order Number',
    riqi: 'Date',
    yuanshidingdantupian: 'Original Order Image',
    xuanzegaimuban: 'Select Template',
    shanchumuban: 'Delete Template',
    qingshurudingdanhao: 'Please enter order number',
    kaibanwenjianshifouxiazai: 'Whether the version file is downloaded',
    piliangdaochukaibanwenjian: 'Batch export version files',
    piliangdaochutiaoxingma: 'Batch export barcodes',
    piliangdaochugongyikapian: 'Batch export process cards',
    dengdaikaiban: 'Waiting for version',
    daixiazai: 'To be downloaded',
    yixiazai: 'Downloaded',
    chakantiaoxingma: 'View barcode',
    shengchenggongyikapian: 'Generate process card',
    tiaoxingma: 'Barcode',
    weixiazai: 'Not downloaded',
    yixiazai: 'Downloaded',
    qingxuanzedingdan: 'Please select an order',

    bianjiyuangongxinxi: 'Edit Employee Information',
    xinzengyuangong: 'Add Employee',
    yuangongshenfen: 'Employee Role',
    dengluzhanghao: 'Login Account',
    denglumima: 'Login Password',
    shuruip: 'Please enter IP, leave blank for no restriction, use comma to separate multiple IPs',
    gengxinxinxi: 'Update Information',
    bianjishengchanxiaozu: 'Edit Production Team',
    xinzengshengchanxiaozu: 'Add Production Team',
    xiaozumingcheng: 'Team Name',
    dianzikaibanyuangong: 'Digital Pattern Making Staff',
    shijianjiange: 'Time Interval',
    jiguangcaiqieyuangong: 'Laser Cutting Staff',
    chefengyuangong: 'Sewing Staff',
    chongmianyuangong: 'Filling Staff',
    zaoxingyuangong: 'Modeling Staff',
    penyouyuangong: 'Spray Staff',
    zhijianyuangong: 'QC Staff',
    qingshurumingcheng: 'Please enter name',
    qingxuanzeyuangong: 'Please select employee',
    qingshurushijianjiange: 'Please enter time interval (days)',
    qingshuruxiaozumingcheng: 'Please enter team name',
    xinzengxiaozu: 'Add Team',
    chuangjianshijian: 'Creation Time',
    xiaozuchengyuan: 'Team Members',
    dingdanfangongtongji: 'Order Rework Statistics',
    dingdanwanchengshijian: 'Order Completion Time',
    yuangongxingming: 'Employee Name',
    shifoufangong: 'Need Rework',
    daochudingdan: 'Export Order',
    yichulidingdanshuliang: 'Processed Orders Count',
    weifangongdingdanshuliang: 'Orders Not Reworked Count',
    fangongdingdanshuliang: 'Reworked Orders Count',
    shi: 'Yes',
    fou: 'No',
    yicifangongshuliang: 'First Time Rework Count',
    ercifangongshuliang: 'Second Time Rework Count', 
    sancifangongshuliang: 'Third Time Rework Count',
    fankuineirong: 'Feedback Content',
    dianjishangchuanfankuitu: 'Click to Upload Feedback Image',
    tijiaofankui: 'Submit Feedback',
    qingshuruneironghuoshangchuantupian: 'Please enter content or upload image',
    zhidingshengchanxiaozu: 'Assign Production Team',
    xuanzexiaozu: 'Select Team',
    xuanzedianzikaibanshijian: 'Select Digital Pattern Making Time',
    xiadanshijian: 'Order Time',
    wanchengshijian: 'Completion Time',
    gongchangjiaoqi: 'Factory Delivery Date',
    piliangfenpei: 'Batch Assignment',
    piliangzhidingxiaozu: 'Batch Team Assignment',
    fenpei: 'Assign',
    zhidingxiaozu: 'Assign Team',
    tiaozhengfenpei: 'Adjust Assignment',
    dingdanfenpei: 'Order Assignment',
    gongxuyidianzikaiban: 'Process 1-Digital Pattern Making',
    gongxuerjiguangcaiqie: 'Process 2-Laser Cutting',
    gongxusanchefeng: 'Process 3-Sewing',
    gongxusichongmian: 'Process 4-Filling',
    gongxuwuzaoxing: 'Process 5-Modeling',
    gongxuliupenyou: 'Process 6-Spraying',
    gongxuqizhijian: 'Process 7-Quality Control',
    qingxuanzeyuangongyijiwanchengshijian: 'Please select employee and completion time',
    xuanzeyuangongjishijian: 'Select Employee and Time',
    shengchanfuzeren: 'Production Manager',
    quedingxuanze: 'Confirm Selection',
    tijiaoshuju: 'Submit Data',
    qingxuanzedianzikaibanyuangong: 'Please select digital pattern making staff',
    qingxuanzejiguangcaiqieyuangong: 'Please select laser cutting staff',
    qingxuanzezhijianyuan: 'Please select QC staff',
    fenpeichenggong: 'Assignment Successful',
    denglu: 'Login',
    qingshurudengluzhanghao: 'Please enter login account',
    qingshurudenglumima: 'Please enter login password',
    qingshuruyanzhengma: 'Please enter verification code',
    dengluchenggong: 'Login Successful!',
    dingdanshuliang: 'Order Quantity',
    zhizuozhouqi: 'Production Cycle',
    gukexinxi: 'Customer Information',
    chicun: 'Size',
    zishi: 'Pose',
    zuibaxingzhuang: 'Mouth Shape',
    yanjingyanse: 'Eye Color',
    laliandai: 'Zipper Pocket',
    lianbutupian: 'Face Picture',
    tupianyi: 'Picture 1',
    tupianer: 'Picture 2',
    tupiansan: 'Picture 3',
    tupiansi: 'Picture 4',
    tupianwu: 'Picture 5',
    tupianliu: 'Picture 6',
    tupianqi: 'Picture 7',
    tupianba: 'Picture 8',
    tupianjiu: 'Picture 9',
    tupianshi: 'Picture 10',
    tipianshiyi: 'Picture 11',
    tupianshier: 'Picture 12',
    maopi: 'Blank',
    jiaozhangdeyanse: 'Paw Color',
    tongkongdexingzhuang: 'Pupil Shape',
    huxu: 'Whiskers',
    maochang: 'Hair length',
    maofaxingzhuang: 'Fur Shape',
    touxing: 'Head Shape',
    erduoxingzhuang: 'Ear Shape',
    weibaxingzhuang: 'Tail Shape',
    biziyinying: 'Nose Shadow',
    yanxian: 'Eye Line',
    fujian: 'Attachment',
    fujianer: 'Attachment 2',
    caozuozhe: 'Operator',
    caozuoshijian: 'Operation Time',
    tuji: 'Photo Album',
    caozuofuzeren: 'Operation Manager',
    yujiwanchengshijian: 'Expected Completion Time',
    dingdanrizhi: 'Order Log',
    caozuoneirong: 'Operation Content',
    gukexinxi: 'Customer Information',
    zhiliangjiancezhong: 'Quality Inspection',
    duogepingtaishiyongdouhaofenxiang: 'Separate multiple platforms with commas in English',


    jichuxinxi: 'Basic Information',
    pingtaibianhao: 'Platform Number',
    pinzhong: 'Species',
    xiadanriqi: 'Order Date',
    zhizuozhouqi: 'Production Cycle',
    shifouxuyao: 'Is Required',
    pensetu: 'Color Spray Chart',
    maochangtu: 'Fur Length Chart',
    qingdingzhi: 'Light Customization',
    maodemaopi: 'Cat Blank',
    jiaozhangya: 'Paw Color',
    tongkongxingzhuang: 'Pupil Shape',
    fenxiao: 'Distribution',
    qita: 'Others',
    lijichuangjian: 'Create Now',
    quanbu: 'All',
    jinsheng:'Remaining',
    tian:'Days',
    biaojiweiyidu: 'Mark as read',
    fenpeikehu:'Assign Customer',


    zhanzi:'Standing',
    zuozi:'Sitting',
    pazai:'Lying',
    cezhan:'Lying on the side',

    zhangzui:'Open mouth',
    biezui:'Close mouth',
    zhangzuituoshe:'Open mouth with tongue',
    biezuituoshe:'Close mouth with tongue',

    chuizhi:'Vertical',
    yuanxing:'Circular',

    xuyao:'Required',
    buxuyao:'Not required',

    zhizuowancheng:'Completed',
    yichaoqi:'Overdue',
    shifouchaoqi:'Is overdue',
    xaizaituji:'Download photo album',
    duanmao:'Short hair',
    changmao:'Long hair',
    fense:'Pink',
    heise:'Black',
    huise:'Gray',
    yichao:'Overdue',

  },
  tongjiObj: {
    daichulidingdan: 'Pending Orders',
    yichulidingdan: 'Processed Orders',
    shengchanzhongdingdan: 'Orders in Production',
    yiwanchengdingdan: 'Completed Orders',
    yifahuodingdan: 'Shipped Orders',
    fangongdingdan: 'Rework Orders',
    yiquxiaodingdan: 'Canceled Orders',
  },
  shaixuanObj: {
    dingdanbianhao: 'Order Number',
    xiadanpingtai: 'Order Platform',
    gongchanbianhao: 'Factory Number',
    dingdanleixing: 'Order Type',
    dingdanzhuangtai: 'Order Status',
    chongwupinzhong: 'Pet Species',
    shengchanjindu: 'Production Progress',
    shengchanzhiliushijian: 'Production Retention Time',
    dingdanriqi: 'Order Date',
    jiaohuoriqi: 'Delivery Date',
    xiaoshouyuan: 'Sales Representative',
    sousuo: 'Search',
    chongzhi: 'Reset',
    qingshuru: 'Please enter',
    qingxuanze: 'Please select',
    gongxujiezhishijian: 'Process Cutoff Time',
    shijiwanchengshijian: 'Actual Completion Time',
    fangongwanchengshijian: 'Rework Completion Time',
    zhi: 'To',
    kaishiriqi: 'Start Date',
    jieshuriqi: 'End Date',
  },
  ordersObj: {
    dingdanbianhao: 'Order Number (Platform Number)',
    xiadanpingtai: 'Order Platform',
    gongchanbianhao: 'Factory Number',
    dingdanleixing: 'Order Type',
    dingdanriqi: 'Order Date',
    jiaohuoriqi: 'Delivery Date',
    dingdanzhuangtai: 'Order Status',
    chongwupinzhong: 'Pet Species',
    shengchanjindu: 'Production Progress',
    shengchanzhiliushijian: 'Production Retention Time',
    caozuo: 'Operation',
    quxiaodingdan: 'Cancel Order',
    dingdanfahuo: 'Ship Order',
    fankuixinxi: 'Feedback Information',
    xiugaidingdan: 'Modify Order',
    dingdanxiangqing: 'Order Details',
    jiazaizhong: 'Loading',
    daichuli: 'Pending',
    yichuli: 'Processed',
    fangong: 'Rework',
    chongmianwanchengshijian: 'Filling Completion Time',
    shijiwanchengshijian: 'Actual Completion Time',
    fangongwanchengshijian: 'Rework Completion Time',
    shangbugongxuweichuli: 'Previous step not processed',
    wanchenggongxu: 'Complete process',
    wanchengfangong: 'Complete rework',
    chexiao: 'Cancel',
    kaibanxiangqing: 'Pattern details',
    xuanzexiayibugongxu: 'Select next step process',
    gongxu: 'Process',
    zhijianwanchengshijian: 'Inspection Completion Time',
    shijiwanchengshijian: 'Actual Completion Time',
    zaoxingwanchengshijian: 'Modeling Completion Time',

    jianyantongguo: 'Inspection passed',
    jianyanbutongguo: 'Failed (Rework)',
    zhijianyijian: 'Quality inspection comments',
    shangchuanchengpintu: 'Upload finished product image',
    dianjishangchuan: 'Click to upload',
    zhinengshangchuan: 'Only jpg/png files less than 10MB can be uploaded',
    penyouwanchengshijian: 'Spray completion time',
    kaibanwanchengshijian: 'Pattern making completion time',
    shoudongkaiban: 'Manual pattern making',
    mubankaiban: 'Template pattern making',
    xiugaikaiban: 'Modify pattern',
    caiqiewanchengshijian: 'Cutting completion time',
    chefengwanchengshijian: 'Sewing completion time',
    yundanhao: 'Tracking Number',
  },
  dingdanzhuangtaiObj: {
    fangong: 'Rework',
    daichuli: 'Waiting for production',
    shengchanzhong: 'In Production',
    yiwancheng: 'Completed Pending Shipment',
    yifahuo: 'Shipped',
    yiquxiao: 'Canceled',
    zhiliangjiancezhong: 'Quality Inspection',
  },
  shengchanzhuangtaiObj: {
    dianzikaiban: 'Electronic patterning',
    jiguangcaiqie: 'Laser cutting',
    chefeng: 'Sewing',
    chongmian: 'Filling',
    zaoxing: 'Modeling',
    penyou: 'Spraying',
    zhijian: 'Inspection',
  },
  gaimimaObj: {
    genggaimima: 'Update password',
    xinmima: 'New password',
    querenmima: 'Confirm password',
    quxiao: 'Cancel',
    lijixiugai: 'Update immediately',
    xiugaichenggongqingchongxindenglu: 'Update successfully, please log in again!',
    liangcimimabuyizhi: 'Two passwords do not match!',

    chongzhimima: 'Reset password',
    mima: 'Password',
    tijiaoxinxi: 'Submit information',
  },
  yuangongObj: {
    xingming: 'Name',
    zhanghao: 'Account',
    yuangongshenfen: 'Job',
    zhuangtai: 'Status',
    chuangjianriqi: 'Create date',
    caozuo: 'Operation',
    bianji: 'Edit',
    chongzhimima: 'Reset password',
    jinyong: 'Disable',
    qiyong: 'Enable',
    shanchu: 'Delete',
    xinzenggongren: 'Add employee',
    jiazaizhong: 'Loading',
  

    dianhua: 'Phone',
    guojia: 'Country',
    shengfen: 'Province',
    chengshi: 'City',
    youbian: 'Zip code',
    dizhi: 'Address',


  },
  zhiweiObj: {
    jingli: 'Manager',
    xiaoshou: 'Sales',
    dianzikaiban: 'Electronic patterning',
    jiguangcaiqie: 'Laser cutting',
    chefeng: 'Sewing',
    chongmian: 'Filling',
    zaoxing: 'Modeling',
    penyou: 'Spraying',
    zhijian: 'Inspection',
    kehu: 'Customer',
  }
}


// WEBPACK FOOTER //
// ./src/locales/lang/en-US.js